export const ACCOUNTS_KEY = "accounts";
export const USER_SETTINGS = "user-settings";
